import {
  customElement,
  html,
  DeesElement,
  property,
  type TemplateResult,
  cssManager,
  css,
  type CSSResult,
  unsafeCSS,
} from '@design.estate/dees-element';

import * as domtools from '@design.estate/dees-domtools';
import { themeDefaultStyles } from '../../00theme.js';

declare global {
  interface HTMLElementTagNameMap {
    'dees-spinner': DeesSpinner;
  }
}

@customElement('dees-spinner')
export class DeesSpinner extends DeesElement {
  public static demoGroups = ['Feedback'];
  public static demo = () => html`
    <dees-spinner></dees-spinner>
    <dees-spinner status="success"></dees-spinner>
    <dees-spinner status="error"></dees-spinner>
    <dees-spinner size=${64} status="success"></dees-spinner>
    <dees-spinner .size=${64} status="error"></dees-spinner>
  `;

  @property({
    type: Number,
  })
  accessor size = 20;

  @property({
    type: String,
  })
  accessor bnw: boolean = false;

  @property()
  accessor status: 'normal' | 'pending' | 'success' | 'error' = 'normal';

  constructor() {
    super();
  }

  public static styles = [
    themeDefaultStyles,
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
      }

      /* --dees-spinner-color lets a spinner on a coloured surface (an accent button face,
         a toast) match that surface's foreground. It is read as an inherited fallback
         rather than declared on :host, because a :host declaration would outrank the
         value an ancestor sets. Unset consumers keep the previous token. */
      #loading {
        position: relative;
        transition: none;
        display: flex;
        justify-content: center;
        align-content: center;
        background: transparent;
        border: 3px solid
          color-mix(
            in srgb,
            var(--dees-spinner-color, var(--dees-color-text-primary)) 20%,
            transparent
          );
        border-radius: 50%;
        border-top-color: var(--dees-spinner-color, var(--dees-color-text-primary));
        animation: spin 1s ease-in-out infinite;
        -webkit-animation: spin 1s ease-in-out infinite;
      }

      #loading.success {
        border: none;
        border-radius: 50%;
        animation: none;
        -webkit-animation: none;
      }

      #loading.error {
        border: none;
        border-radius: 50%;
        animation: none;
        -webkit-animation: none;
      }

      @keyframes spin {
        to {
          -webkit-transform: rotate(360deg);
        }
      }
      @-webkit-keyframes spin {
        to {
          -webkit-transform: rotate(360deg);
        }
      }

      dees-icon {
        position: absolute;
        height: 100%;
        width: 100%;
      }

      @media (prefers-reduced-motion: reduce) {
        #loading {
          animation: none;
          -webkit-animation: none;
        }
      }
    `,
  ];

  render() {
    return html`
      <style>
        #loading {
          width: ${this.size}px;
          height: ${this.size}px;
        }
        #loading.success {
          color: ${this.bnw ? 'var(--dees-color-text-primary)' : 'var(--dees-color-text-success)'};
          
        }
        #loading.error {
          color: ${this.bnw ? 'var(--dees-color-text-primary)' : 'var(--dees-color-text-error)'};
        }
        dees-icon {
          font-size: ${this.size}px;
        }
      </style>
      <div class="${this.status}" id="loading">
        ${(() => {
          if (this.status === 'success') {
            return html`<dees-icon style="transform: translateX(1%) translateY(3%);" .icon=${'lucide:CircleCheck'}></dees-icon>`;
          } else if (this.status === 'error') {
            return  html`<dees-icon .icon=${'lucide:CircleX'}></dees-icon>`;
          }
        })()}
      </div>
    `;
  }
}
